import React from 'react';
import { Tag } from 'antd';
import Icon from '@ant-design/icons';
import { Trans } from 'react-i18next';
import classNames from 'classnames';
import { isAiQuickReply } from '../../../../../helpers/aiQuickReplies';
import { ReactComponent as BotIcon } from '../../../../../assets/icons/leftMenuIcons/botActive.svg';
import QuickReplyRegularMessage from '../QuickReplyRegularMessage';
import styles from './QuickReplyPreview.module.scss';
import { useStore } from '../../../../../store/rootStore';
const QuickReplyPreview = ({ quickReply, className, messageClassName, onClick, showHeader = true, showMessages = true, }) => {
    const { activeChatStore: { chat } } = useStore();
    const { send, display } = quickReply;
    const contents = send.contents;
    if (!chat)
        return null;
    const isAi = isAiQuickReply(quickReply);
    return (React.createElement("div", { className: classNames(styles.quickReplyPreview, className), onClick: onClick },
        showHeader && (display.title || display.note || isAi) && (React.createElement("div", { className: styles.quickReplyHeader },
            display.title && React.createElement("h3", { className: styles.title }, display.title),
            display.note && (React.createElement("p", { className: styles.description }, display.note)),
            isAi && (React.createElement(Tag, { color: "cyan", className: styles.aiAnswerTag, icon: React.createElement(Icon, { component: BotIcon, className: styles.aiAnswerIcon }) },
                React.createElement(Trans, { i18nKey: "aiAnswer" }))))),
        showMessages && contents.map((messageContent) => (React.createElement(QuickReplyRegularMessage, { key: messageContent.type + JSON.stringify(messageContent), content: messageContent, chat: chat, className: classNames(styles.messageItem, messageClassName), onClick: onClick })))));
};
export default QuickReplyPreview;
